module.exports = __webpack_public_path__ + "img/rule10.png";